// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { buildThirdPartyScripts } from '@features/script-loader/configs';
import packageJson from '../../package.json';
import { Environment } from './interfaces';

export const environment: Environment = {
    production: false,
    version: packageJson.version,
    configPath: 'config.json',
    federation: {
        manifest: '/assets/federation.manifest.dev.json',
    },
    chatbot: {
        chatBase: '/assets/scripts/chatbase/chatbase.js',
    },
    scripts: buildThirdPartyScripts({
        cookieHubSrc: 'https://cdn.cookiehub.eu/c2/5fa8e5c0.js',
        clarityId: 'ok2md5sqy2',
        gtmId: 'GTM-WK53JCD',
        jiraCollectorSrcs: [
            'https://syniotec.atlassian.net/s/d41d8cd98f00b204e9800998ecf8427e-T/1jmxwi/b/8/c95134bc67d3a521bb3f4331beb9b804/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?locale=en-US&collectorId=6103e9c9',
        ],
    }),
    imports: [
        // StoreDevtoolsModule.instrument({
        //     maxAge: 50,
        //     autoPause: true,
        //     connectInZone: true,
        // }),
    ],
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
